import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
const { formatText } = require('core/i18n').i18n;
import { resultSelected as glossaryResultSelected } from 'actions/glossary';
import ReactHtmlParser from 'react-html-parser';


class FormattedDescription extends Component {
    componentDidMount() {
        const { selectGlossaryResult } = this.props;
        const elements = this.element.querySelectorAll('[data-term]')

        // For ie11 cannot use forEach when get elements with querySelectorAll
        // so keep this code to work in ie11
        for (let i = 0; i < elements.length; i++) {
            const elem = elements[i]
            const term = elem.getAttribute('data-term');
            elem.addEventListener('click', () => selectGlossaryResult(term));
        }
    }

    render() {
        const { className, value } = this.props;
        const parsedComponent = ReactHtmlParser(formatText(value));
        return (
            <span
                className={classNames('formatted-description', className)}
                ref={element => this.element = element}
            >
                {parsedComponent}
            </span>
        );
    }
}


FormattedDescription.propTypes = {
    className: PropTypes.string,
    selectGlossaryResult: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
};

const mapDispatchToProps = dispatch => ({
    selectGlossaryResult: term => dispatch(glossaryResultSelected({ result: term }))
});


module.exports.constructor = FormattedDescription;
module.exports.FormattedDescription = connect(null, mapDispatchToProps)(FormattedDescription);
